
import http from '@/base/api/public'
import querystring from 'querystring'

let apiUrl = require('@/../config/sysConfig')
// 検索
export const noticeDetailGet = (userCd) => {
    return http.requestGet(apiUrl.apiUrl_NoticeDetailSearch + '?userCd=' + userCd)
}


// 検索
export const noticeSave = (saveParams, userCd) => {
    return http.requestPost(apiUrl.apiUrl_Notice + '?userCd=' + userCd, saveParams)
}


// WEBPACK FOOTER //
// ./src/module/api/b_0001.js